import React, { useState, useEffect, useCallback } from "react";
import "./LoginScreen.css";
import bg_img from "url:../OS/background.jpg";
import avatar_img from "url:./pp.webp";

const LOAD_DURATION = 1800;

export function LoginScreen({ onLogin }) {
    const [time, setTime] = useState(new Date());
    const [phase, setPhase] = useState("idle"); // idle | loading | out

    useEffect(() => {
        const interval = setInterval(() => setTime(new Date()), 1000);
        return () => clearInterval(interval);
    }, []);

    const handleLogin = useCallback(() => {
        if (phase !== "idle") return;
        setPhase("loading");
        setTimeout(() => {
            setPhase("out");
            setTimeout(onLogin, 700);
        }, LOAD_DURATION);
    }, [phase, onLogin]);

    useEffect(() => {
        const handleKey = () => handleLogin();
        window.addEventListener("keydown", handleKey);
        return () => window.removeEventListener("keydown", handleKey);
    }, [handleLogin]);

    const hours = time.getHours().toString().padStart(2, "0");
    const minutes = time.getMinutes().toString().padStart(2, "0");

    const isLangFr = navigator.language.toLowerCase().startsWith("fr");

    const daysFr = [
        "Dimanche",
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi",
    ];
    const daysEn = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
    ];
    const monthsFr = [
        "janvier",
        "février",
        "mars",
        "avril",
        "mai",
        "juin",
        "juillet",
        "août",
        "septembre",
        "octobre",
        "novembre",
        "décembre",
    ];
    const monthsEn = [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
    ];

    const dateStr = isLangFr
        ? `${daysFr[time.getDay()]} ${time.getDate()} ${monthsFr[time.getMonth()]}`
        : `${daysEn[time.getDay()]}, ${monthsEn[time.getMonth()]} ${time.getDate()}`;

    const hint = isLangFr ? "Cliquez pour vous connecter" : "Click to log in";
    const loadingText = isLangFr ? "Connexion en cours…" : "Signing in…";

    return (
        <div
            className={`login-screen login-screen--${phase}`}
            style={{ backgroundImage: `url(${bg_img})` }}
            onClick={handleLogin}
        >
            <div className="login-screen__overlay" />

            <div className="login-screen__time-section">
                <div className="login-screen__time">
                    {hours}
                    <span className="login-screen__colon">:</span>
                    {minutes}
                </div>
                <div className="login-screen__date">{dateStr}</div>
            </div>

            <div className="login-screen__user-section">
                <div
                    className={`login-screen__avatar${phase === "loading" ? " login-screen__avatar--loading" : ""}`}
                >
                    <img src={avatar_img} alt="User Avatar" />
                </div>
                <div className="login-screen__username">Tom</div>

                {phase === "idle" && (
                    <div className="login-screen__hint">{hint}</div>
                )}

                {phase === "loading" && (
                    <div className="login-screen__loader">
                        <div
                            className="login-screen__loader-bar"
                            style={{ "--bar-duration": `${LOAD_DURATION}ms` }}
                        />
                        <span className="login-screen__loading-text">
                            {loadingText}
                        </span>
                    </div>
                )}
            </div>
        </div>
    );
}
